module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gglist"
    }
  }, [_c('div', {
    staticClass: "gglist"
  }, [_c('List', {
    attrs: {
      "list": _vm.gglist,
      "name": "zcgl",
      "ShowTime": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50f37ad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/zcgl/page/gglist.vue
// module id = 889
// module chunks = 2